<template>
    <div class="text-center">
        <v-menu
            bottom
            left
            :light="true"
            offset-y
            origin="top right"
            v-model="openAppBox"
            :close-on-content-click="false"
            transition="scale-transition">

            <template v-slot:activator="{ attrs, on }">
                <v-btn min-width="0" text v-bind="attrs" v-on="on" min-height="48">
                    <v-icon>mdi-rocket-outline</v-icon>
                    <span>SC2 Apps</span>
                </v-btn>
            </template>

            <v-card>

                <v-list style="background-color: unset">
                    <v-list-item v-for="(link, i) in links.filter(x => x.group === 1)" :key="'a_' + i">
                        <a :href="link.href" target="_blank" style="text-decoration: none; width: 100%">
                            <div  class="pa-2 link-container" style="display: flex; align-items: center; width: 100%">
                                <v-icon v-bind:class="{active: link.activePage === true}" class="mr-1 link-icon" style="color: white; border-radius: 50%; height: 28px; width: 28px;font-size:1.1rem;">{{ link.icon }}</v-icon>
                                <p class="ml-2 mr-6 ma-0" style="font-size: 1.1rem; color: #666" v-text="link.text"></p>
                                <v-icon style="margin-left: auto" color="primary">mdi-chevron-right</v-icon>
                            </div>
                        </a>
                    </v-list-item>
                    <v-divider class="my-2"></v-divider>
                    <v-list-item v-for="(link, i) in links.filter(x => x.group === 2)" :key="'b_' + i">
                        <a :href="link.href" target="_blank" style="text-decoration: none; width: 100%">
                            <div  class="pa-2 link-container" style="display: flex; align-items: center; width: 100%">
                                <v-icon v-bind:class="{active: link.activePage === true}" class="mr-1 link-icon" style="color: white; border-radius: 50%; height: 28px; width: 28px;font-size:1.1rem;">{{ link.icon }}</v-icon>
                                <p class="ml-2 mr-6 ma-0" style="font-size: 1.1rem; color: #666" v-text="link.text"></p>
                                <v-icon style="margin-left: auto" color="primary">mdi-chevron-right</v-icon>
                            </div>
                        </a>
                    </v-list-item>
                    <v-divider class="my-2"></v-divider>
                    <v-list-item v-for="(link, i) in links.filter(x => x.group === 3)" :key="'c_' + i">
                        <a :href="link.href" target="_blank" style="text-decoration: none; width: 100%">
                            <div  class="pa-2 link-container" style="display: flex; align-items: center; width: 100%">
                                <v-icon v-bind:class="{active: link.activePage === true}" class="mr-1 link-icon" style="color: white; border-radius: 50%; height: 28px; width: 28px;font-size:1.1rem;">{{ link.icon }}</v-icon>
                                <p class="ml-2 mr-6 ma-0" style="font-size: 1.1rem; color: #666" v-text="link.text"></p>
                                <v-icon style="margin-left: auto" color="primary">mdi-chevron-right</v-icon>
                            </div>
                        </a>
                    </v-list-item>
                </v-list>

            </v-card>
        </v-menu>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import {
        CONF_ENVIRONMENT,
        CONF_CLIENT_URLS_SC2_FLIGHTS_PROD,
        CONF_CLIENT_URLS_SC2_FLIGHTS_TEST,
        CONF_CLIENT_URLS_SC2_CALENDAR_PROD,
        CONF_CLIENT_URLS_SC2_CALENDAR_TEST,
        CONF_CLIENT_URLS_SC2_PEOPLE_PROD,
        CONF_CLIENT_URLS_SC2_PEOPLE_TEST,
        CONF_CLIENT_URLS_SC2_HOTELS_PROD,
        CONF_CLIENT_URLS_SC2_HOTELS_TEST,
        CONF_CLIENT_URLS_SC2_VACATION_PROD,
        CONF_CLIENT_URLS_SC2_VACATION_TEST,
        CONF_CLIENT_URLS_SC2_REPORTS_PROD,
        CONF_CLIENT_URLS_SC2_REPORTS_TEST,
        CONF_CLIENT_URLS_SC2_TIMESTATS_PROD,
        CONF_CLIENT_URLS_SC2_TIMESTATS_TEST,
        CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD,
        CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST,
        CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD,
        CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST,
        CONF_CLIENT_URLS_SC2_TRAININGS_PROD,
        CONF_CLIENT_URLS_SC2_TRAININGS_TEST,
        CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD,
        CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST,
    } from '../../../config'


    export default {
        name: 'appboxmenue',

        /* >>> *************************************************************** / /* Components */
        components: {}, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({
            openAppBox: false,
            links: [
                {
                    icon: 'mdi-airplane-takeoff',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_FLIGHTS_PROD : CONF_CLIENT_URLS_SC2_FLIGHTS_TEST,
                    text: 'SunFlight',
                    group: 1,
                    activePage: false
                },
                {
                    icon: 'mdi-account-switch',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_CALENDAR_PROD : CONF_CLIENT_URLS_SC2_CALENDAR_TEST,
                    text: 'Calendar',
                    group: 1,
                    activePage: false
                },
                {
                    icon: 'mdi-account-multiple',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_PEOPLE_PROD : CONF_CLIENT_URLS_SC2_PEOPLE_TEST,
                    text: 'People',
                    group: 2,
                    activePage: false
                },
                {
                    icon: 'mdi-bed',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_HOTELS_PROD : CONF_CLIENT_URLS_SC2_HOTELS_TEST,
                    text: 'Hotels',
                    group: 2,
                    activePage: false
                },
                {
                    icon: 'mdi-beach',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_VACATION_PROD : CONF_CLIENT_URLS_SC2_VACATION_TEST,
                    text: 'Vacation',
                    group: 3,
                    activePage: false
                },
                {
                    icon: 'mdi-briefcase-download',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_REPORTS_PROD : CONF_CLIENT_URLS_SC2_REPORTS_TEST,
                    text: 'Reports',
                    group: 3,
                    activePage: true
                },
                {
                    icon: 'mdi-av-timer',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_TIMESTATS_PROD : CONF_CLIENT_URLS_SC2_TIMESTATS_TEST,
                    text: 'TimeStats',
                    group: 3,
                    activePage: false
                },
                {
                    icon: 'mdi-airport',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD : CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST,
                    text: 'AirportQualifications',
                    group: 3,
                    activePage: false
                },
                {
                    icon: 'mdi-account-check',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD : CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST,
                    text: 'ConfirmationOverview',
                    group: 3,
                    activePage: false
                },
                {
                    icon: 'mdi-account-school',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_TRAININGS_PROD : CONF_CLIENT_URLS_SC2_TRAININGS_TEST,
                    text: 'Trainings&Checks',
                    group: 3,
                    activePage: false
                },
                {
                    icon: 'mdi-book-account',
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD : CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST,
                    text: 'DutyPlan',
                    group: 3,
                    activePage: false
                },
            ]
        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {
        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
		created: function () {

            let me = this;


            me.$toc('>>> views/shared/components/core/SaveDutyPlanChangesMenue.vue >>> created');
            // >>> ----------------------------------------
            // eventBus.$on('onallemployeesloaded', this.onLoad_AllEmployees);

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/shared/components/core/SaveDutyPlanChangesMenue.vue >>> beforeDestroy');

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_DutyPlanChanges',
            ]),


            /******************************************************************* 'Listeners - Emit'
            * Listeners:
            *******************************************************************/




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/


        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .v-list-item {
        padding: 0 12px;
    }
    .link-container:hover {
        cursor: pointer;
    }
    .link-icon {
        background-color: #92949C;
    }
    .link-icon.active, .link-container:hover .link-icon {
        background-color: #AB3B7A;
    }
</style>

<style>
    .v-card__subtitle, .v-card__text, .v-card__title  {
        padding: 0px !important;
    }

    .v-card__title {
        font-size: 18px;
    }
</style>